export default __webpack_public_path__ + "static/media/expand.f32327b8.svg";